<template>
	<div class="index">
		<div class="module-search">
			<div class="module-search-input">
				<el-input placeholder="输入标题关键字进行查询" v-model="searchVal" @input="checked(searchVal)" prefix-icon="el-icon-search">
				</el-input>
			</div>
			<div class="module-search-screen" :class="screenModal?'show-modal':''" @click="clickShowHide">
				<Icon type="ios-funnel" size="16" /> 筛选</div>
			<!-- <div class="screen-div-fix" v-show="screenModal" @click="screenModal = false"></div> -->
			<!-- v-show="screenModal" -->
			<div class="screen-div" :style="screenModal?'visibility:visible':'visibility:hidden'" id="screen-modal" ref="screenModal">
				<div class="screen-title">按部门选择</div>
				<div class="screen-item" v-for="(item,index) in categorys" @click="clickCategorys(item,index)" :class="index==index_t?'screen-item-active':''"
				 :key="index">{{item}}</div>
			</div>
		</div>


		<div class="module-class" v-for="(item,index) in pageRouter" :key="index" :style="index == 0?screenModal?'margin-top: '+ height +'px':'margin-top: 42px':''">
			<div class="module-title">
				{{item.key}}
			</div>
			<div class="module-main">
				<div class="class-item" v-for="(data,idx) in item.val" @click="routerLink(data.link)" :key="data.link" :class="idx>=item.showLen - (item.showLen % 4)?'no-border':''"
				 v-show="idx <= item.showLen">
					<div class="second">
						<div class="self">
							<div class="icon iconfont" :class="data.icon"></div>
							<div class="text">{{data.text}}</div>
						</div>
					</div>
				</div>
				<div class="class-item no-border" @click="showAll(index)" v-if="item.fold && item.showLen == 6">
					<div class="second">
						<div class="self">
							<div class="icon iconfont icon-gengduo" style="color: #c2c6ca;"></div>
							<div class="text">更多</div>
						</div>
					</div>
				</div>
				<div class="class-item no-border" @click="showPart(index)" v-if="!item.fold && item.showLen == item.val.length && item.showLen > 6">
					<div class="second">
						<div class="self">
							<div class="icon iconfont icon-shouqi2" style="color: #c2c6ca;"></div>
							<div class="text">收起</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<!--<div class="online-loading-div" v-show="fullscreenLoading"></div>
		 <div class="online-loading" v-show="fullscreenLoading">
			<i class="el-icon-loading"></i>
			<span>正在为你创建群聊，请稍等......</span>
		</div> -->

		<!-- <div id="default_drag_comp" class="back-icon" @click="onlineContact" @touchstart="down" @touchmove="move" @touchend="end">
			<img class="online-icon" src="../assets/image/online.png" alt="">
			<div class="online-text">在线咨询</div>
		</div> -->

	</div>
</template>

<script>
	import {
		getStartCounsel
	} from '@/api/approval'
	import stringUtils from "../assets/js/stringUtil.js";
	export default {
		data() {
			return {
				searchVal: '',
				screenModal: false,
				pageRouter: [],

				flags: false,
				position: {
					x: 0,
					y: 0
				},
				nx: "",
				ny: "",
				dx: "",
				dy: "",
				xPum: "",
				yPum: "",
				name: "",
				parentName: "",
				maxW: null,
				maxH: null,
				platform: "", //当前打开H5页面的环境
				categorys: [],
				index_t: 0,
				height: 0,
				fullscreenLoading: false,
				flowSettingDatas:null,
				logInfo:null
			}
		},
		mounted() {
			var cc = stringUtils.GetQueryString("cc");
			if(cc){
				var timestamp=new Date().getTime();
				this.$router.push("/index?time="+timestamp);
			}
			this.logInfo = this.getLoginUserInfo();
			var ua = navigator.userAgent.toLowerCase();
			if (ua.match(/micromessenger/i) == 'micromessenger') {
				this.platform = 'micromessenger';
			} else if (ua.match(/wxwork/i) == 'wxwork') {
				this.platform = 'wxwork'
			}
			this.GetFlowSetting();
			// this.$http({
			// 	url: this.$httpUrl.GetCategorys,
			// 	method: "get",
			// }).then(res => {
			// 	this.categorys = [];
			// 	if (res.data != null) {
			// 		for (var i = 0; i < res.data.Body.length; i++) {
			// 			this.categorys.push(res.data.Body[i]);
			// 		}
			// 		this.categorys.unshift('全部')
			// 	}
			// });
		},
		watch: {
			screenModal: function(val, old) {
				if (val) {
					this.height = this.$refs.screenModal.offsetHeight + 48;
				}
			}
		},

		methods: {
			// 实现移动端拖拽
			down() {
				let default_drag_comp = document.querySelector("#default_drag_comp");
				this.flags = true;
				var touch;
				if (event.touches) {
					touch = event.touches[0];
				} else {
					touch = event;
				}
				this.maxW = document.documentElement.clientWidth - default_drag_comp.offsetWidth;
				this.maxH = document.documentElement.clientHeight - default_drag_comp.offsetHeight;

				this.position.x = touch.clientX - default_drag_comp.offsetLeft;
				this.position.y = touch.clientY - default_drag_comp.offsetTop;
				this.dx = touch.clientX;
				this.dy = touch.clientY;
			},
			move(event) {
				event.preventDefault();
				let default_drag_comp = document.querySelector("#default_drag_comp");
				if (this.flags) {
					var touch;
					if (event.touches) {
						touch = event.touches[0];
					} else {
						touch = event;
					}

					this.nx = touch.clientX - this.position.x;
					this.ny = touch.clientY - this.position.y;

					if (this.nx < 0) {
						this.nx = 0;
					} else if (this.nx > this.maxW) {
						this.nx = this.maxW;
					}
					if (this.ny < 0) {
						this.ny = 0;
					} else if (this.ny >= this.maxH) {
						this.ny = this.maxH;
					}

					default_drag_comp.style.left = this.nx + "px";
					default_drag_comp.style.top = this.ny + "px";

					//阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
					document.addEventListener(
						"touchmove",
						function() {
							// event.preventDefault();
						},
						false
					);
				}
			},
			//鼠标释放时候的函数
			end() {
				this.flags = false;
			},
			setCookie(key, value, t) {
				var oDate = new Date();
				oDate.setDate(oDate.getDate() + t);
				document.cookie = key + "=" + value + "; expires=" + oDate.toDateString();
			},
			clickShowHide() {
				this.screenModal = !this.screenModal
			},
			//点击在线咨询
			// onlineContact() {
			// 	let getLoginUserInfo = this.getLoginUserInfo();

			// 	if (this.platform != 'wxwork' && this.platform != 'micromessenger') {
			// 		this.$message.error('请在企业微信或微信中打开该页面！');
			// 		return
			// 	}
			// 	this.fullscreenLoading = true;


			// 	let empNo = getLoginUserInfo.EmpNo
			// 	getStartCounsel(empNo).then(response => {
			// 		if (response.ErrCode == 0) {
			// 			this.fullscreenLoading = false;
			// 			this.$message.success('在企业微信中已为您发起群聊，请前往咨询！');
			// 		} else {
			// 			this.fullscreenLoading = false;
			// 			this.$message.error(response.ErrMsg);
			// 		}
			// 	})
			// },
			routerLink(link) {
				var timestamp=new Date().getTime();
				link = link+"&time="+timestamp;
				this.$router.push(link);
			},
			showAll(index) {
				this.pageRouter[index].fold = false;
				this.pageRouter[index].showLen = this.pageRouter[index].val.length
			},
			showPart(index) {
				this.pageRouter[index].fold = true;
				this.pageRouter[index].showLen = 6;
			},
			GetFlowSetting() {
				let that = this;
				let empInfo = this.logInfo.fullName+"#"+this.logInfo.PositionName+"#"+this.logInfo.JobLevel;
				if(that.flowSettingDatas!=null){
					that.pageRouter = [];
					var datas = [];
					for(var i = 0;i<that.flowSettingDatas.length;i++){
						if(that.parentName == '' || that.flowSettingDatas[i].ParentName == that.parentName){
							if(that.name == '' || that.flowSettingDatas[i].Name.indexOf(that.name)>-1){
								datas.push(that.flowSettingDatas[i])
							}
						}
					}
					for (var i = 0; i < datas.length; i++) {
						
						if (this.GetValByKey(datas[i].ParentName, that.pageRouter) == null) {
							that.pageRouter.push({
								key: datas[i].ParentName,
								val: [],
								fold: false
							})
						}
						var data = {
							text: datas[i].Name,
							icon: 'icon-shenqingdanhao blue',
							link: "/" + datas[i].Url + "?templateId=" + datas[i].TemplateId
						};
						that.pageRouter[that.GetValByKey(datas[i].ParentName, that.pageRouter)].val.push(data);
					}
					for(var j=0;j<that.pageRouter.length;j++){
						that.pageRouter[j].showLen = that.pageRouter[j].val.length
					}
				}else{
					that.flowSettingDatas = [];
					this.$http({
						url: this.$httpUrl.GetFlowSetting + "?name=" + that.name + "&parentName=" + that.parentName,
						method: "get",
					}).then(res => {
						that.pageRouter = [];
						var datas = res.data.Body;
						for (var i = 0; i < datas.length; i++) {
							let isOk = false;
							if(datas[i].VisibleRangeAuthority!=null){
								for(var j = 0; j<datas[i].VisibleRangeAuthority.length;j++){
									if(eval(datas[i].VisibleRangeAuthority[j]).test(empInfo)){
										if (this.GetValByKey(datas[i].ParentName, that.pageRouter) == null) {
											that.pageRouter.push({
												key: datas[i].ParentName,
												val: [],
												fold: false
											})
										}
										let category = this.categorys.find( e => e == datas[i].ParentName);
										if(category==null){
											this.categorys.push(datas[i].ParentName)
										}
										isOk = true;
										break;
									}
								}
							}
							else{
								if (this.GetValByKey(datas[i].ParentName, that.pageRouter) == null) {
									that.pageRouter.push({
										key: datas[i].ParentName,
										val: [],
										fold: false
									})
								}
								isOk = true;
								let category = this.categorys.find( e => e == datas[i].ParentName);
								if(category==null){
									this.categorys.push(datas[i].ParentName)
								}
							}
							if(isOk){
								var data = {
									text: datas[i].Name,
									icon: 'icon-shenqingdanhao blue',
									link: "/" + datas[i].Url + "?templateId=" + datas[i].TemplateId
								};
								that.pageRouter[that.GetValByKey(datas[i].ParentName, that.pageRouter)].val.push(data);
								that.flowSettingDatas.push(datas[i]);
							}
						}
						for(var j=0;j<that.pageRouter.length;j++){
							that.pageRouter[j].showLen = that.pageRouter[j].val.length
						}
						this.categorys.unshift('全部')
					});
				}
				
			},
			clickCategorys(categoryName, index) {
				if (this.parentName == categoryName) {
					this.parentName = "";
					this.index_t = 0;
				} else {
					this.parentName = categoryName;
					this.index_t = index;
				}

				if (categoryName == '全部') {
					this.parentName = "";
				}
				this.GetFlowSetting();
			},
			checked(val) {
				console.log(val)
				this.name = val;
				this.GetFlowSetting();
			},
			GetValByKey(key, list) {
				for (var i = 0; i < list.length; i++) {
					if (list[i].key == key) {
						return i;
					}
				}
				return null;
			},
		}
	}
</script>

<style lang="less">
	.index {
		width: 100%;
		padding: 8px;
	}

	.index::-webkit-scrollbar {
		display: none;
	}

	.module-search {
		width: 100%;
		margin-bottom: 8px;
		position: fixed;
		background: #f5f5f5;
		z-index: 777;
		left: 0px;
		top: 0px;
		padding: 8px;

		.module-search-input {
			display: inline-block;
			background: #FFFFFF;
			width: calc(100% - 52px);
			border-radius: 17px;
			border: 1px solid #DCDFE6;
			box-sizing: border-box;
			color: #606266;
			padding-left: 4px;
			position: relative;


			i {
				height: 100%;
				width: 25px;
				font-size: 20px;
				text-align: center;
			}

			.el-input__icon {
				line-height: 32px !important;
			}

			input {
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				display: inline-block;
				font-size: inherit;
				height: 32px;
				line-height: 32px;
				border-radius: 16px;
				outline: 0;
				border: 0;
				width: calc(100% - 25px);
			}
		}

		.module-search-screen {
			display: inline-block;
			width: 52px;
			text-align: center;
			line-height: 34px;
		}

		.show-modal {
			color: #409eff;
		}

		.screen-div-fix {
			position: fixed;
			width: 100%;
			height: 100vh;
			z-index: 666;
			background: rgba(0, 0, 0, 0);
			left: 0;
			top: 0;
		}

		.screen-div {
			position: absolute;
			width: calc(100% - 16px);
			padding: 20px 15px;
			top: 47px;
			left: 8px;
			border: 1px solid #DCDFE6;
			border-radius: 18px;
			z-index: 777;
			opacity: 1;
			background: #FFFFFF;
			box-shadow: 4px 4px 6px #DCDFE6;

			.screen-title {
				color: #555;
				padding: 0 16px;
			}

			.screen-item {
				display: inline-block;
				padding: 0 16px;
				height: 28px;
				line-height: 28px;
				border-radius: 14px;
				margin: 6px 10px;
				background: #f1f1f1;
			}

			.screen-item-active {
				background: #409eff;
				color: #fff;
			}
		}
	}

	.module-class {
		width: 100%;
		background: #fff;
		border-radius: 5px;
		margin-bottom: 8px;
	}

	.module-class:first-child {
		margin-top: 42px !important;
	}

	.module-title {
		width: 100%;
		padding: 0 10px;
		height: 38px;
		line-height: 38px;
		color: #333;
		font-weight: 500;
		border-bottom: 1px solid #e7e7e7;
	}

	.module-main {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.class-item {
			width: 25%;
			text-align: center;
			position: relative;
			border-right: 1px solid #e7e7e7;
			border-bottom: 1px solid #e7e7e7;

			.second {
				position: relative;
				width: 100%;
				padding-top: 100%;

				.self {
					position: absolute;
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;

					.icon {
						width: 100%;
						text-align: center;
						margin-top: 8px;
						font-size: 24px;
					}

					.green {
						color: #62bfc4;
					}

					.blue {
						color: #6cb3f3;
					}

					.text {
						color: #353535;
						font-size: 12px;
						line-height: 1.5;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						padding: 0 6px;
					}
				}
			}
		}

		.class-item:nth-child(4n) {
			border-right: none;
		}

		.no-border {
			border-bottom: none;
		}


	}

	.back-icon {
		position: fixed;
		z-index: 999;
		right: 20px;
		bottom: 40px;
		text-align: center;
		padding: 4px;
		width: 60px;
		height: 60px;
		border-radius: 50%;
		background-color: #6cb3f3;
		touch-action: none;

		.online-icon {
			width: 26px;
			height: 26px;
			display: inline-block;
			margin-top: 4px;
		}

		.online-text {
			width: 100%;
			text-align: center;
			font-size: 11px;
			color: #FFFFFF;
			position: absolute;
			left: 0;
			bottom: 8px;
		}
	}

	.online-loading-div {
		position: fixed;
		width: 100%;
		z-index: 9999;
		height: 100vh;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	.online-loading {
		position: fixed;
		width: 80%;
		left: 10%;
		padding: 20px;
		text-align: center;
		top: 30vh;
		z-index: 10009;

		i {
			display: block;
			text-align: center;
			margin: 0 auto;
			font-size: 42px;
			color: #fff;
		}

		span {
			display: block;
			line-height: 34px;
			text-align: center;
			font-size: 14px;
			margin-top: 10px;
			color: #fff;
		}
	}
</style>
